<template>

</template>

<script>
    import Vue from 'vue';
    import Translations from '@/store/translations';
    import { mapState, mapActions } from 'vuex'
    import store from '@/store/index.js'
    import DropDownMenu from'@/components/common/DropDownMenu.vue';
    import EventBus from '@/eventbus';

    export default {
        name: "PlanningActions",
        store,
        components: {
            DropDownMenu
        },
        computed: {
            Translations: () => Translations,
            ...mapState(["currentDayTemplate", "isLoadingDayTemplate"]),
        },
        data() {
            return {
                menus: [
                    {
                        external: true,
                        iconClass: "fa-cog",
                        title: Translations.sections.dayTemplates.details.actions.edit,
                        action: function () { EventBus.$emit("editDayTemplate", this.currentDaytemplate.uid); }
                    },
                    {
                        external: false, iconClass: "fa-cog", title: Translations.sections.dayTemplates.details.actions.edit,
                        action: function () { EventBus.$emit("editDayTemplate", this.currentDaytemplate.uid); }
                    },
                    {
                        external: false, iconClass: "fa-clone", title: Translations.sections.dayTemplates.details.actions.duplicate,
                        action: function () { EventBus.$emit("duplicateDayTemplate", this.currentDaytemplate.uid); }
                    },
                    { external: false, isDivider: true },
                    {
                        external: false, iconClass: "fa-trash-alt", title: Translations.sections.dayTemplates.details.actions.delete,
                        action: function () { EventBus.$emit("deleteDayTemplate", this.currentDaytemplate.uid); }
                    },
                ]
            }
        },
    }
</script>

<style scoped>
</style>
